import React, { Component } from "react";
import ChiffresClesStatistiquesUsage from "../Base/ChiffresClesStatistiquesUsage/ChiffresClesStatistiquesUsage";
import ChartsStatistiquesUsages from "../Base/ChartsStatistiquesUsages/ChartsStatistiquesUsages";

class AdminStatistiquesUsages extends Component {
    constructor() {
      super();
      this.state = {
        error: false,
        newFetch: false
      };
    }

    getTagsRequest() {
      let res = "";
      if (window.selectedTags) {
        window.selectedTags.forEach(tag => {
          res.length
            ? (res = res + "&tags[]=" + tag)
            : (res = res + "?tags[]=" + tag);
        });
      }
      return res;
    }

    updateData() {
      try {
        this.setState({newFetch: !this.state.newFetch});
      } catch (e) {
        console.log(e);
      }
    }

    componentDidUpdate(prevProps, prevState) {
      if (prevState.error) {
        this.setState({ error: false });
      }
    }

    notifyError() {
      toast.error(
        "Les tags sélectionnés sont trop précis, merci de sélectionner moins de tags."
      );
      this.setState({ error: true });
    }


  render() {
    return (
      <div className="animated fadeIn">
          <ChiffresClesStatistiquesUsage
            request={"/" + this.props.params.id}
            isAdmin={false}
            notifyError={this.notifyError.bind(this)}
            error={this.state.error}
            newFetch={this.state.newFetch}
          />
        <ChartsStatistiquesUsages
          request={"/" + this.props.params.id}
          isAdmin={true}
        />
      </div>
    );
  }
}

export default AdminStatistiquesUsages;



// WEBPACK FOOTER //
// ./src/views/AdminStatistiquesUsages/AdminStatistiquesUsages.js